export default {
  title: 'Bookli is the platform where you can book padel courts at our partners.',
  text: 'We have made it easy for you to book and with us, you can pay with both MobilePay and credit card. Once you have made a booking, you can also add your teammates and opponents - then they will also be notified about the booking!',
  final: 'Good match from the Bookli team!',
  next: 'Next'
}